import Fade from "react-reveal/Fade";
import resume from "./resume.png"
import pdfResume from"./sammy_nguyen_cv.pdf"
import React, { useState} from "react";

function Contact() {
  const [isActive, setIsActive] = useState(false);
  const handleClick = event => {
    setIsActive(current => !current);
  };

  return (
    <Fade>
      <div id="contact">
        <div id="presentation" className="my-5">
          <h1 className="text-3xl font-bold sm:text-4xl md:text-6xl mb-6">
            Contact <span className="text-zinc-400">Me</span>
          </h1>
          <p className="opacity-90 w-100">
            If you need to reach me, you can email me at{" "}
            <a className="underline decoration-purple-500 hover:decoration-blue-950 text-lg" href="mailto:sammynguyen92000@gmail.com">sammynguyen92000@gmail.com</a>.
            <br></br>
            My GitHub profile can be found at{" "}
            <a className="underline decoration-purple-500 hover:decoration-blue-950 text-lg"  href="https://github.com/sammyngy">github.com/sammyngy</a>,
            showcasing my technical skills. .<br></br>
            My professional experience can be viewed on my LinkedIn profile at{" "}
            <a className="underline decoration-purple-500 hover:decoration-blue-950 text-lg" href="https://linkedin.com/in/sammyngy">
              linkedin.com/in/sammyngy
            </a>
            .<br></br>
          </p>
          <div className="text-center m-auto mt-5">
            <a href={pdfResume} className="btn text-white" target="_blank" rel="noopener noreferrer" download="sammy_nguyen_cv.pdf">
              Download Resume
            </a>
          </div>
          <div className="pdf-viewer m-auto mt-5">
            <img className={isActive ? 'rounded-xl drop-shadow-lg blur-none' : 'rounded-xl drop-shadow-lg blur-sm'} src={resume} alt="Resume Sammy Nguyen"></img>
            {!isActive ? 
              <button className="btn" onClick={handleClick}>
              View Resume
            </button> : null}
          </div>
        </div>
      </div>
    </Fade>
  );
}

export default Contact;
